<template>
    <v-container class="fill-height">
        <v-row class="justify-center">
            <v-col
                cols="12"
                lg="4"
            >
                <router-view></router-view>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>

</style>
